/**
 * Takes a string and removes the symbols that are considered invalid for slugs and similar text ids
 * @param text input string
 */
export const slugify = (text?: string): string => {
  return (text || "").replace(/\s+/gi, "_").replace(/[^0-9a-zA-Z_-]/gi, "").toLowerCase();
}
